import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import moment from 'moment';
import * as api from 'core/api';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
import * as payment from 'core/payment';
import { throws } from 'assert';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export function requiredIfCard(value) {
    if (this.paymentModel.selectedPaymentType.kind === 'CreditCardInplace'
        && !value
        && !this.paymentModel.selectedPaymentType.isYandexPay) 
    {
        return false;
    }
    return true;
}

export function cardCode(value) {
    if (value) {
        const card = new utils.Card(this.paymentModel.card.number, value);

        if (!card.cvcIsValid) {
            return false;
        }
    }
    return true;
}

export function cardNumber(value) {
    if (value) {
        const card = new utils.Card(value, this.paymentModel.card.code);

        if (!card.numberIsValid) {
            return false;
        }
    }
    return true;
}

export function cardExpired(value) {
    if (value && moment(value).isBefore(moment())) {
        return false;
    }
    return true;
}

@WithRender
@Component({
    validations: {
        paymentModel: {
            card: {
                holder: { requiredIfCard },
                number: { requiredIfCard, cardNumber },
                expiry: { requiredIfCard },
                code: { requiredIfCard, cardCode }
            }
        }
    }
})
export default class PaymentFormComponent extends Vue {
    @Prop()
    amount: number;

    @Prop()
    currentUser: api.UserWithBonuses;

    @Prop()
    paymentModel: payment.PaymentModel;

    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flight: flights.FlightModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    @Prop()
    showSbp: boolean;

    alreadyInPackageModal = {
        message: '',
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        acceptCallback: () => { },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        refuseCallback: () => { }
    }

    bonusFormVisible: boolean = false;
    bonusInputValue: number | null = null;

    cardExpiryMonth: string = '';
    cardExpiryYear: string = '';

    tooltipActivator: string | null = null;
    tooltipText: string | null = null;
    tooltipVisible: boolean = false;
    tooltipTimeout: number | null = null;
    parceladoState: string = '';

    get moneyWallPrice() {
        return utils.Payment.calcMoneyWallPrice(this.amount, this.flight.legs[0].segments[0].departureDate);
    }

    get yandexSmsProduct() {
        return this.reservation ? this.reservation.productsOfYandex.find(item => item.product.externalId = 'MegoPackageSuperSms') : null;
    }
    get relatedProducts() {
        return this.reservation.getPackageRelatedProductsByExternalId(this.yandexSmsProduct!.product.externalId);
    }
    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        if (product) {
            if (product.selected != value) {
                if (product.product.id !== 49) { 
                    (<any>this).$ga.sendEvent('flights.booking',
                        `btn.product.confirm.${value ? 'ok' : 'cancel'}.step${product.product.stepNumber}.kit${product.product.kitId || ''}.id${product.product.id}`,
                        `flights.booking.btn.product.confirm.${value ? 'ok' : 'cancel'}.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
                        this.gaParams
                    );
                }
            }
            product.selected = value;
            if (value) {
                new api.RetailRocket().productSelected({
                    flightKey: api.RetailRocketCL.flightKey,
                    productId: product.product.id
                });
            }

            console.log('Payment!');
            console.log(product.selected);
            console.log(this.relatedProducts);
            
            if (value) {
                product.choiceType = api.ProductChoiceType.manualAccepted;
                if (this.relatedProducts.length) {
                    this.relatedProducts.forEach(relatedProduct => {
                        let productToUnselect: flights.ProductModel | undefined = undefined;

                        if (relatedProduct.criterion == 'equal') {
                            productToUnselect = this.reservation.products.find(product =>
                                product.product.externalId == relatedProduct.externalId
                            );
                        }

                        if (relatedProduct.criterion == 'popup') {
                            productToUnselect = this.reservation.products.find(product =>
                                utils.String.startsWith(product.product.externalId, relatedProduct.externalId)
                            );
                            
                            if (productToUnselect && productToUnselect!.selected) {
                                this.alreadyInPackageModal.message = i18next.t('label_product_already_in_package', <any>{ i: productToUnselect!.product.name });
                                this.alreadyInPackageModal.acceptCallback = () => {
                                    (<any>this.$refs).alreadyInPackageDialog.isActive = false;
                                    productToUnselect!.selected = false;
                                };
                                this.alreadyInPackageModal.refuseCallback = () => {
                                    (<any>this.$refs).alreadyInPackageDialog.isActive = false;
                                    this.paymentModel.selectedPaymentTab = 'card';
                                };
                                (<any>this.$refs).alreadyInPackageDialog.isActive = true;
                            }
                        }

                        if (productToUnselect && relatedProduct.criterion !== 'popup') {
                            productToUnselect.selected = false;
                        }
                    });
                }
            } else {
                product.choiceType = api.ProductChoiceType.manualDenied;
            }
        }
    }

    flagSmsPackage: number = 0;

    @Watch('paymentModel.selectedPaymentTab')
    onPaymentTabChange(value: string) {
        // @Todo Удалить или отрефакторить yandex код
        const bookingSms = this.reservation?.products.find(item => item.product.externalId == 'MegoPackageSuperSms' && item.product.saleType == 'BookingForm');

        this.paymentModel.onSelectedPaymentTabChanged();
        const selectedPayment = this.paymentModel.selectedPaymentType;
        const selectedPaymentMethod = value === 'yandexpay' ? this.paymentModel.selectedPaymentMethod : '';

        if(value == 'parcelado'){
            this.parceladoState = 'loading';
            this.onParceladoSelect();
            (<any>this).$ga.sendEvent('flights.booking', 'step3.payment.installment', 'flights.booking.step3.payment.installment', this.gaParams);
        }
        if (!this.gaAlreadySubmitted.includes('flights.booking.payment.changed')) {
            (<any>this).$ga.sendEvent(
                'flights.booking',
                'payment.changed',
                'flights.booking.payment.changed',
                this.gaParams
            );
            this.gaAlreadySubmitted.push('flights.booking.payment.changed');
        }
        (<any>this).$ga.sendEvent(
            'flights.booking',
            `payment.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}selected`.toLowerCase(),
            `flights.booking.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}selected`.toLowerCase(),
            this.gaParams
        );
        if(bookingSms?.selected == true && value === 'yandexpay') {
            bookingSms.selected = false;
            this.onProductSelectionChange(this.yandexSmsProduct!, value === 'yandexpay');
            this.flagSmsPackage = 1;
        } else {
            this.onProductSelectionChange(this.yandexSmsProduct!, value === 'yandexpay');
        }
        if(this.yandexSmsProduct){this.flagSmsPackage == 1 && this.yandexSmsProduct!.selected != true ? bookingSms!.selected = true : null};  
    }

    getAvailableBonuses() {
        return this.paymentModel.calculateAvailableBonuses(this.reservation.getTotalPrice(), this.currentUser.bonuses);
    }

    getBonusesAppliedLabel(): string {
        return i18next.t('label_bonuses_payment_applied', <any>{
            i: (<any>this.$options.filters).number(this.currentUser.bonuses.status.currentBalance),
            j: (<any>this.$options.filters).number(this.paymentModel.bonusAmount)
        });
    }

    getBonusesEmptyLabel(): string {
        return i18next.t('label_bonuses_payment_empty', <any>{
            i: (<any>this.$options.filters).number(this.currentUser.bonuses.status.currentBalance),
            j: (<any>this.$options.filters).number(this.getAvailableBonuses())
        });
    }

    getBonusesNotEnoughLabel(): string {
        return i18next.t('label_bonuses_payment_not_enough', <any>{
            i: (<any>this.$options.filters).number(this.currentUser.bonuses.status.currentBalance),
            j: (<any>this.$options.filters).number(this.currentUser.bonuses.status.leftToFirstUse)
        });
    }

    getCommissionLabel(v: number): string {
        return i18next.t('label_payment_commission_withvalue', <any>{ i: (<any>this.$options.filters).price(v) });
    }

    getMonthlyPaymentLabel(): number {
        return this.reservation.getTotalPrice() / 6;
    }

    isMarkerOwner(markerOwner: string): boolean {
        return utils.Cookies.getMarkerOwner() === markerOwner;
    }

    onParceladoSelect(){
        setTimeout(()=>{
            this.parceladoState = '';
        }, 2750);
    }

    onBonusCancel() {
        this.paymentModel.bonusAmount = 0;
        this.bonusInputValue = null;
    }

    onBonusSubmit() {
        if (this.bonusInputValue
            && this.bonusInputValue > 0
            && this.bonusInputValue <= this.currentUser.bonuses.status.currentBalance) {
            const availableBonuses = this.getAvailableBonuses();

            if (this.bonusInputValue > availableBonuses) {
                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('error'),
                    text: i18next.t('error_bonuses_payment_limit', <any>{
                        i: (<any>this.$options.filters).number(availableBonuses)
                    }),
                    btnOkHandler: () => {
                        this.bonusInputValue = availableBonuses;
                        this.paymentModel.bonusAmount = this.bonusInputValue;
                        this.bonusFormVisible = false;
                    }
                });
                return;
            }

            this.paymentModel.bonusAmount = this.bonusInputValue;
            this.bonusFormVisible = false;
        }
    }

    onCardNumberInput() {
        this.$emit('card-number-input');
    }

    onCardExpiryMonthInput(value: string) {
        const newValue = value;
        const oldValue = this.cardExpiryMonth;

        if (newValue.match(/^[2-9]$/) && oldValue.length != 2) {
            this.cardExpiryMonth = `0${newValue}`;
        } else {
            this.cardExpiryMonth = newValue;
        }
        if (this.cardExpiryMonth.length == 2) {
            (<any>this.$refs).cardExpiryYear.focus();
        }
        this.assignCardExpiry();
    }

    onCardExpiryMonthChange() {
        this.assignCardExpiry();
    }

    onCardExpiryMonthBlur() {
        if (this.cardExpiryMonth.length == 1) {
            this.cardExpiryMonth = `0${this.cardExpiryMonth}`;
        }
    }

    onCardExpiryYearInput(value: string) {
        this.cardExpiryYear = value;
        if (this.cardExpiryYear.length == 2) {
            (<any>this.$refs).cardHolder.focus();
        }
        this.assignCardExpiry();
    }

    onCardExpiryYearChange() {
        this.assignCardExpiry();
    }

    onCardExpiryYearBlur() {
        if (this.cardExpiryYear.length == 1) {
            this.cardExpiryYear = `0${this.cardExpiryYear}`;
        }
    }

    selectPaymentTab(tab:string){
        this.paymentModel.selectedPaymentTab = tab;
    }

    assignCardExpiry() {
        if (this.cardExpiryMonth && this.cardExpiryYear) {
            const m = moment(this.cardExpiryMonth + this.cardExpiryYear, 'MMYY', true);

            if (m.isValid()) {
                this.paymentModel.card.expiry = m.endOf('month').format('YYYY-MM-DD'); // Use ISO-format.
            } else {
                this.paymentModel.card.expiry = '';
            }
        } else {
            this.paymentModel.card.expiry = '';
        }
    }

    showTooltip(target, text) {
        (<any>this).$refs.tooltip.isActive = false;

        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
        }

        this.$nextTick(() => {
            this.tooltipText = text;
            this.tooltipActivator = target;
            (<any>this).$refs.tooltip.isActive = true;

            this.tooltipTimeout = window.setTimeout(() => {
                (<any>this).$refs.tooltip.isActive = false;
            }, 2000);
        });
    }

    showMoreDetails(type: string, title: string) {
        (<any>this).$root.$refs.dialogContent.open(`payment.${type}`, title);
        
        const selectedPayment = this.paymentModel.selectedPaymentType;
        const selectedPaymentMethod = type === 'yandexpay' ? this.paymentModel.selectedPaymentMethod : '';

        (<any>this).$ga.sendEvent(
            'flights.booking',
            `payment.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}details`.toLowerCase(),
            `flights.booking.${selectedPayment.kind}.${selectedPayment.paymentTypeId}.${selectedPaymentMethod ? selectedPaymentMethod.type + '.' : ''}details`.toLowerCase(),
            this.gaParams
        );
    }

    onCardHolderInput() {
        this.paymentModel.card.holder = utils.String.normalizeCardHolder(
            this.paymentModel.card.holder,
            () => {
                this.showTooltip(
                    (<any>this.$refs).cardHolder.$el,
                    i18next.t('error_letters_latin_only')
                );
            }
        );
        // Hack to render new value
        (<any>this.$refs).cardHolder.lazyValue = this.paymentModel.card.holder;
    }

    onCardHolderChange() {
        this.paymentModel.card.holder = this.paymentModel.card.holder.toUpperCase();
    }

    /**
     * Return error or null if credit card form valid. Called by parent control;
     */
    validate() {
        if (
            this.paymentModel.selectedPaymentType.kind === 'CreditCardInplace'
            && !this.paymentModel.selectedPaymentType.isYandexPay
            && this.paymentModel.selectedPaymentTypeId !== 'MobiMoneySbp'
        ) {
            this.$v.paymentModel!.card!.$touch();

            if (this.$v.paymentModel!.card!.$error) {
                let error: string | null = null;

                if (!error && this.$v.paymentModel!.card!.number!.$error) {
                    error = i18next.t('error_card_number_wrong');
                }

                if (!error && !this.cardExpiryMonth) {
                    error = i18next.t('error_card_expiry_month_empty');
                }

                if (!error && !this.cardExpiryYear) {
                    error = i18next.t('error_card_expiry_year_empty');
                }

                if (!error && this.$v.paymentModel!.card!.expiry!.$error) {
                    error = i18next.t('error_card_expiry_wrong');
                }

                if (!error && this.$v.paymentModel!.card!.holder!.$error) {
                    error = i18next.t('error_card_holder_empty');
                }

                if (!error && this.$v.paymentModel!.card!.code!.$error) {
                    error = i18next.t('error_card_code_wrong');
                }

                if (!error) {
                    error = i18next.t('error_fields');
                }

                return error;
            }
        }

        return null;
    }
}
